import { ReactNode } from 'react';
import da from '../../translations/da.json';
import de from '../../translations/de.json';
import en from '../../translations/en.json';
import fi from '../../translations/fi.json';
import nl from '../../translations/nl.json';
import no from '../../translations/no.json';
import sv from '../../translations/sv.json';
import type { CellulaTexts } from '../../utils/hooks/use_text';
import { CellulaI18nProviderContext } from './i18n_provider.context';

function getTranslations(): Record<CellulaLanguage, CellulaTexts> {
	return {
		da: da,
		de: de,
		en: en,
		fi: fi,
		nl: nl,
		no: no,
		sv: sv,
	};
}

export type CellulaLanguage = 'da' | 'de' | 'en' | 'fi' | 'nl' | 'no' | 'sv';

interface CellulaI18nProviderProps {
	/**
	 * Provide static texts.
	 */
	lang: CellulaLanguage;
	textOverrides?: Partial<CellulaTexts>;
	children: ReactNode;
}
function CellulaI18nProvider({ lang, textOverrides, children }: CellulaI18nProviderProps): JSX.Element {
	const translations = getTranslations();
	const texts = { ...translations[lang], ...textOverrides };

	return <CellulaI18nProviderContext.Provider value={{ texts: texts }}>{children}</CellulaI18nProviderContext.Provider>;
}

/* ########################################################################## */
/* ############################### PUBLIC API ############################### */
/* ########################################################################## */

export type { CellulaI18nProviderProps };
/**
 * Provider to provide static texts to Cellula components. If no texts are
 * provided Cellula will default to english.
 */
export { CellulaI18nProvider };
